import { render, staticRenderFns } from "./AdminRoue.vue?vue&type=template&id=21b3dd12&"
import script from "./AdminRoue.vue?vue&type=script&lang=js&"
export * from "./AdminRoue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports